import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import LeiService from '../../../../services/leis-auth';
import InfiniteScroll from '../../utils/infiniteScroll';
import Lei from './lei';


const ListarLeis = () => {


    async function fetchLeis() {
        await seraQueAcabou();
        const response = await LeiService.listar({ limit: true, cod_lei: cod });
        if (response.data.length >= 1) {
            let count = Math.floor(numLeis / 20) + 1
            for (let i = 1; i < count; i++) {
                setLeis([...leis, ...response.data])
                setCod(response.data[response.data.length - 1]["cod_lei"])
                if (response.data.length < 20) {
                    setAindaTem(false)
                }
            }
        } else {
            setLeis([])
            setVazio(true)
        }
    }

    const [leis, setLeis] = useState([]);
    const [data, setData] = useState(false);
    const [jornal, setJornal] = useState(false);
    const [arquivo, setArquivo] = useState(false);
    const [ementa, setEmenta] = useState(null);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [lei, setLei] = useState("");
    const [cod, setCod] = useState(null);
    const [numLeis, setNumLeis] = useState(null);
    const [aindaTem, setAindaTem] = useState();



    async function fetchLeisIn() {
        await pegaNumLeis();
        const response = await LeiService.listar({ limit: true });
        if (response.data.length >= 1) {
            setLeis(response.data)
            setVazio(false)
            setCod(response.data[response.data.length - 1]["cod_lei"])
            if (response.data.length == 20) {
                setAindaTem(true)
            } else {
                setAindaTem(false)
            }
        } else {
            setLeis([])
            setVazio(true)
        }
    }

    async function pegaNumLeis() {
        const response = await LeiService.numLeis({ todas: true })
        setNumLeis(parseInt(response.data))
    }

    const seraQueAcabou = async () => {
        if (leis.length >= numLeis + 1) {
            setAindaTem(false)
        } else {
            setAindaTem(true)
        }
    }

    const handleEditar = (id) => {
        setLei(id);
        setEditar(true)
    }

    const handleEmenta = (id) => {
        setLei(id);
        setEmenta(true)
    }

    const handleJornal = (id) => {
        setLei(id);
        setJornal(true)
    }

    const handleData = (id) => {
        setLei(id);
        setData(true)
    }

    const handleArquivo = (id) => {
        setLei(id);
        setArquivo(true)
    }

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a lei?')) {
            await LeiService.deletar(id)
            alert("Lei deletada com sucesso!")
            fetchLeis();
        }
    }

    useEffect(() => {
        fetchLeisIn();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/leis/editar/${lei}`} />
        )
    } else if (data) {
        return (
            <Navigate to={`/restrito/leis/data/${lei}`} />
        )
    } else if (jornal) {
        return (
            <Navigate to={`/restrito/leis/jornal/${lei}`} />
        )
    } else if (arquivo) {
        return (
            <Navigate to={`/restrito/leis/arquivo/${lei}`} />
        )
    } else if (ementa) {
        return (
            <Navigate to={`/restrito/leis/ementa/${lei}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setLeis={setLeis}
                        setVazio={setVazio}
                        setAindaTem={setAindaTem}
                        fetchLeisIn={fetchLeisIn}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1}>
                            {leis.map((lei, index) =>
                                <Lei
                                    fetchLeisIn={fetchLeisIn}
                                    lei={lei}
                                    key={index}
                                    editar={handleEditar}
                                    arquivo={handleArquivo}
                                    ementa={handleEmenta}
                                    jornal={handleJornal}
                                    data={handleData}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                        {aindaTem ?
                            <Fragment>
                                <p>Carregando mais leis...</p>
                                <InfiniteScroll Listar={fetchLeis} />
                            </Fragment>
                            : <p>Todas as leis já foram exibidas :)</p>}
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarLeis;